export default {
    title: "Organisation verknüpfen",
    organisation: 'Organisation',
    role: 'Rolle',
    attachOrganisation: 'Organisation verknüpfen',
    attachOrganisationSuccess: 'Die Organisation wurde erfolgreich verknüpft.',
    attachOrganisationError: 'Die Organisation konnte nicht verknüpft werden.'
}